import React from 'react'
import { TextInput } from 'react-admin'
import { CreateGuesser } from 'theme/components'

export const RegionCreate = (props) => (
  <CreateGuesser {...props} variant="outlined" redirect="list">
    <TextInput source="name" />
  </CreateGuesser>
)
